import AppBar from '../Appbar'
import AppRoutes from '../Routes'
import { memo, useState } from 'react'
import Box from '@mui/material/Box'

const Main = ({
  appbarOptions,  
  routes,
  mobileSearchOpen,
  avatarMenuItems,
  mobileMenuOpen,
  setMobileMenuOpen,
  setMobileSearchOpen,
  toggleDarkmode,
  menuWidth
}) => {
  const [header, setHeader] = useState()  
  return (
    <Box
      component="main"
      sx={(theme) => ({
        flex: '1',
        width: '100%',
        flexGrow: 1,
        overflowY: 'auto',
        position: 'relative',
      height: '100vh', 
      bgcolor: theme.palette.mode === 'light' ? theme.palette.grey[100] : null
      })}>
      <AppBar
        header={header}        
        toggleDarkmode={toggleDarkmode}
        menuWidth={menuWidth}
        appbarOptions={appbarOptions}
        routes={routes}
        searchIsOpen={mobileSearchOpen}
        avatarMenuItems={avatarMenuItems}
        onOpenMenu={() => setMobileMenuOpen(!mobileMenuOpen)}
        onOpenSearch={() => setMobileSearchOpen(!mobileSearchOpen)}
      />
      <Box
        sx={(theme) => ({
          padding: theme.spacing(2),
          maxHeight: 'calc(100% - 64px)',
          overflowY: 'auto'
        })}
      >
        <AppRoutes setHeader={setHeader} appRoutes={routes} />
      </Box>
    </Box>
  )
}
export default memo(Main)
